<template>
	<section class="section">
		<Loading :active.sync="loading"></Loading>
		<div class="products-order container-fluid">
			<div class="columns header is-vcentered">
				<div class="column">
					<a class="button is-default" href="/admin/bid">Vissza</a>
				</div>
				<div class="column is-6 has-text-centered-tablet">
					<div class="is-size-3">{{ auction ? auction.name : '-' }}</div>
				</div>
				<div class="column has-text-right-tablet">
					<b-button class="button is-success" @click="saveOrder">Mentés</b-button>
				</div>
			</div>
			<div class="columns headers">
				<div class="column">
					<label class="label">Sorszám</label>
				</div>
				<div class="column">
					<label class="label">Rendezés</label>
				</div>
				<div class="column is-2">
					<label class="label">Rendezési segédszám</label>
				</div>
				<div class="column is-5">
					<label class="label">Termék neve</label>
				</div>
				<div class="column is-2">
					<label class="label">Kategória</label>
				</div>
				<div class="column has-text-right-tablet">
					<label class="label">Kikiáltási ár</label>
				</div>
			</div>
			<div class="columns border-bottom is-vcentered" :id="'row-' + id" v-for="(bid, id) in bids" v-bind:key="id">
				<div class="column">{{ id + 1 }}</div>
				<div class="column">
					<b-button @click.native="sortByOrderNum(id, 0)" icon-right="arrow-up"></b-button>
					<b-button @click.native="sortByOrderNum(id, 1)" icon-right="arrow-down"></b-button>
				</div>
				<div class="column is-2">
					<b-input type="number" :id="id" :value="bids[id].exp_order" v-on:blur="sortByNum"></b-input>
				</div>
				<div class="column is-5 truncate nowrap" :title="bid.Product.name">
					{{ bid.Product.name }}
				</div>
				<div class="column is-2">
					<span v-for="(cat, id) in bid.Product.Categories" :key=id>
						<span v-if="cat.type == 1">{{ cat.name }}</span>
					</span>
				</div>
				<div class="column has-text-right-tablet">
					{{ bid.price | toCurrency($data._this, 'HUF') }}
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
	name: 'ProductsOrder',
	components: { Loading },
	data() {
		return {
			_this: this,
			loading: false,
			user: {},
			bids: [],
			auction: {},
		}
	},
	methods: {
		saveOrder() {
			var _this = this
			_this.loading = true
			_this.$http
				.post('/bids/save-order', _this.bids)
				.then(() => {
					_this.loading = false
					_this.$buefy.snackbar.open({
						message: _this.$t('Saved'),
						queue: false,
					})
				})
				.catch((error) => {
					console.log('saveOrder', error)
					_this.loading = false
					_this.$buefy.snackbar.open({
						message: _this.$t('Save failed'),
						type: 'is-danger',
						duration: 5000,
						queue: false,
					})
				})
		},
		getAuctionProducts(auction_id) {
			var _this = this
			_this.loading = true
			this.$http
				.post('bid/auction/' + auction_id)
				.then((response) => {
					_this.bids = response.data.bids//.reverse();
					_this.auction = response.data.auction
					_this.loading = false
				})
				.catch((error) => {
					console.log('getAuctionProducts:', error)
					_this.loading = false
				})
		},
		sortByNum(item) {
			this.bids[item.target.id].exp_order = parseInt(item.target.value)
			this.sortByOrderNum(item.target.id)
		},
		sortByOrderNum(id, order) {
			var _this = this
			if (typeof order !== 'undefined') {
				if (order) {
					//lefelé
					_this.setColor(id, 'lightgray')
					if (_this.bids[id + 1]) {
						document.getElementById('row-' + (id + 1)).classList.add('animateUp')
						document.getElementById('row-' + id).classList.add('animateDown')
						document.getElementById('row-' + id).classList.add('zind')
						_this.setColor(id + 1, 'whitesmoke')
						setTimeout(function () {
							document.getElementById('row-' + (id + 1)).classList.remove('animateUp')
							document.getElementById('row-' + id).classList.remove('animateDown')
							document.getElementById('row-' + id).classList.remove('zind')
							
							/*_this.bids[id].exp_order = _this.bids[id].exp_order + 10
							if (_this.bids[id + 1]) {
								_this.bids[id + 1].exp_order = _this.bids[id + 1].exp_order - 10
							}*/

							var tmp = _this.bids[id].exp_order;;
							if (_this.bids[id + 1]) {
								var tmp2 = _this.bids[id +1].exp_order;;
								_this.bids[id + 1].exp_order = tmp;
							}
							_this.bids[id].exp_order = tmp2;
							// eslint-disable-next-line no-undef
							_this.bids = _.sortBy(_this.bids, ['exp_order', 'Product.name'])//.reverse()
						}, 500)
					}
				} else {
					//felfelé
					_this.setColor(id, 'lightgray')
					if (_this.bids[id - 1]) {
						document.getElementById('row-' + id).classList.add('animateUp')
						document.getElementById('row-' + id).classList.add('zind')
						document.getElementById('row-' + (id - 1)).classList.add('animateDown')
						_this.setColor(id - 1, 'whitesmoke')
						setTimeout(function () {
							document.getElementById('row-' + id).classList.remove('animateUp')
							document.getElementById('row-' + id).classList.remove('zind')
							document.getElementById('row-' + (id - 1)).classList.remove('animateDown')

							/*_this.bids[id].exp_order = _this.bids[id].exp_order - 10
							if (_this.bids[id - 1]) {
								var tmp2 = _this.bids[id - 1].exp_order;
								_this.bids[id - 1].exp_order = _this.bids[id - 1].exp_order + 10
							}*/

							var tmp = _this.bids[id].exp_order;
							if (_this.bids[id - 1]) {
								var tmp2 = _this.bids[id - 1].exp_order;
								_this.bids[id - 1].exp_order = tmp;
							}
							_this.bids[id].exp_order = tmp2;
							// eslint-disable-next-line no-undef
							_this.bids = _.sortBy(_this.bids, [
								function (o) {
									return parseInt(o.exp_order)
								},
								'Product.name',
							])//.reverse()
						}, 500)
					}
				}
			} else {
				// eslint-disable-next-line no-undef
				_this.bids = _.sortBy(_this.bids, [
					function (o) {
						return parseInt(o.exp_order)
					},
					'Product.name',
				])//.reverse()
			}
		},
		setColor(id, color, time = 500) {
			//document.getElementById('row-'+id).style.outline = "3px solid "+color;
			document.getElementById('row-' + id).style.background = color
			setTimeout(function () {
				//  document.getElementById('row-'+id).style.outline = "0px solid "+color;
				document.getElementById('row-' + id).style.background = 'none'
			}, time)
		},
		getUser() {
			var _this = this
			setTimeout(function () {
				_this.$http
					.get('/users')
					.then((response) => {
						_this.user = response.data.user
						_this.loading = false
						if (!response.data.user.UserPreference || response.data.user.UserPreference.role !== 100) {
							_this.$router.push({ name: 'Login' })
						}
					})
					.catch((err) => {
						console.log('getUser', err)
						_this.loading = false
						_this.$router.push({ name: 'Login' })
					})
			})
		},
	},
	mounted() {
		var _this = this
		this.getUser()

		if (_this.$route.params.auction_id !== undefined) {
			_this.getAuctionProducts(_this.$route.params.auction_id)
			console.log('get product')
		} else {
			console.log('get product == undefined')
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.border-bottom {
	border-bottom: 1px solid lightgray;
}

.animateUp {
	position: relative;
	animation-name: moveUp;
	animation-duration: 0.5s;
}
.animateDown {
	position: relative;
	animation-name: moveDown;
	animation-duration: 0.5s;
}
.zind {
	z-index: 10000 !important;
}
@keyframes moveDown {
	0% {
		left: 0;
		top: 0px;
	}
	50% {
		left: 20px;
	}
	100% {
		left: 0;
		top: 61px;
	}
}
@keyframes moveUp {
	0% {
		right: 0px;
		top: 0px;
	}
	50% {
		right: 20px;
	}
	100% {
		right: 0px;
		top: -61px;
	}
}
</style>
